import { createSlice } from "@reduxjs/toolkit"

import { getActiveUserCount } from "../api/api"


const initialState={
   loading:false,
   error:{}, 
   users: null

}

const getActiveUsersCountSlice= createSlice({
    name:'ActiveUserCount',
     initialState,

     reducers:{

     },

     extraReducers: (builder)=>{
        builder.addCase( getActiveUserCount.pending, (state)=>{
            state.loading = true
            state.error={}
            state.users =null

        })

        builder.addCase( getActiveUserCount.rejected, (state, action)=>{
            state.loading=false
            state.error= action.payload?.errors
            state.users=null
        }

        )
        builder.addCase( getActiveUserCount.fulfilled, (state, action)=>{
            state.loading=false
            state.error={}
            state.users= action.payload
        }
            )


     }

})

export default getActiveUsersCountSlice.reducer